import {
  ADMIN_CERTIFICATES_SETTINGS_EDITABLE_FIELDS,
  AdminCertificatesSettingsEditableFieldsProps,
} from "../../../../models/admin-certificates-settings.models";
import { isNumberField } from "../helpers/admin-certificates-settings-modal.helpers";
import AdminCertificatesSettingsExcludedVesselTypesField from "./AdminCertificatesSettingsExcludedVesselTypesField";
import AdminCertificatesSettingsKpiField from "./AdminCertificatesSettingsKpiField";
import AdminCertificatesSettingsTextField from "./AdminCertificatesSettingsTextField";

const AdminCertificatesSettingsEditableFields = ({
  values,
  vesselTypeOptions,
  saving,
  onChange,
  onExcludedVesselTypesChange,
}: AdminCertificatesSettingsEditableFieldsProps) => (
  <section data-test="admin-certificates-settings-modal-editable-fields">
    <div className="grid gap-4 lg:w-fit lg:grid-cols-[188px_108px_144px_192px]">
      <AdminCertificatesSettingsExcludedVesselTypesField
        value={values.EXCLUDED_VESSEL_TYPES}
        options={vesselTypeOptions}
        saving={saving}
        onChange={onExcludedVesselTypesChange}
      />
      {ADMIN_CERTIFICATES_SETTINGS_EDITABLE_FIELDS.map((field) => {
        if (field === "KPI_INCLUDED") {
          return (
            <AdminCertificatesSettingsKpiField key={field} value={values[field]} saving={saving} onChange={onChange} />
          );
        }

        if (isNumberField(field)) {
          return (
            <AdminCertificatesSettingsTextField
              key={field}
              field={field}
              value={values[field]}
              saving={saving}
              type="number"
              onChange={onChange}
            />
          );
        }

        return (
          <AdminCertificatesSettingsTextField
            key={field}
            field={field}
            value={values[field]}
            saving={saving}
            onChange={onChange}
          />
        );
      })}
    </div>
  </section>
);

export default AdminCertificatesSettingsEditableFields;
